export default "__VITE_PUBLIC_ASSET__6f2430a9__"